import { CART_NOTIFIER_LOAD_SUCCESS, CART_NOTIFIER_LOAD_URL } from 'moduleCartNotifier/constants';

var cartNotifierLoadSuccess = function cartNotifierLoadSuccess(count) {
  return {
    type: CART_NOTIFIER_LOAD_SUCCESS,
    payload: {
      count: count
    }
  };
};

var cartNotifierLoad = function cartNotifierLoad() {
  return function (dispatch, getState, _ref) {
    var networkService = _ref.networkService;
    return networkService.get(CART_NOTIFIER_LOAD_URL).then(function (response) {
      dispatch(cartNotifierLoadSuccess(response.data.count));
    })["catch"](function () {
      return null;
    });
  };
};

export { cartNotifierLoad };